import { render, staticRenderFns } from "./teacher_details.vue?vue&type=template&id=2c3db54c&scoped=true"
import script from "./teacher_details.vue?vue&type=script&lang=js"
export * from "./teacher_details.vue?vue&type=script&lang=js"
import style0 from "./teacher_details.css?vue&type=style&index=0&id=2c3db54c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3db54c",
  null
  
)

export default component.exports